<template>
    <!--<div id="content">-->
    <VideoHome v-if="renderComponent" />
    <OurOffer />
    <Clients />
    <ItemsSlider />
	
	<div class="container">
		<div @click="pageRefs()" class="more-ref">
			<div>
				<div class="img">
					<span><Plus /></span>
				</div>
				<div class="more">
					<span v-html="$t('message.more_ref')"></span>
				</div>
			</div>
		</div>
	</div>
	
	
    <Contact />
    <!--</div>-->
</template>

<script>
import { nextTick, ref } from "vue";
const renderComponent = ref(true);

import VideoHome from "../components/VideoHome.vue";
import OurOffer from "../components/OurOffer.vue";
import ItemsSlider from "../components/ItemsSlider.vue";
import Clients from "../components/Clients.vue";
import Contact from "../components/Contact.vue";
import Plus from "../components/img/Plus.vue";

export default {
    name: "Home",
    data() {
        return {
            isMobile: false,
            renderComponent: true,
        };
    },
    components: {
        VideoHome,
        OurOffer,
        ItemsSlider,
        Clients,
        Contact,
        Plus
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.local = locale;
            this.forceRerender();
        },
    },
    created() {
        let _this = this;
        /**
         * Ajout class si version mobile
         */
        window.addEventListener("resize", function (e) {
            _this.isItMobile();
        });
        this.isItMobile();

        window.addEventListener("scroll", this.handleScroll);
    },
    methods: {
        async forceRerender() {
            this.renderComponent = false;
            await nextTick();
            this.renderComponent = true;
        },
        handleScroll() {
            let homeContent = this.$refs["home-content"];
            if (homeContent) {
                let windowHeight = window.innerHeight;
                let homeContentRect = homeContent.getBoundingClientRect();
                //this.$store.dispatch("app/setPositionSticky", homeContentRect.top - windowHeight < 0 || this.isMobile ? false : true);
            }
        },
        isItMobile() {
            let windowWidth = window.innerWidth;

            if (windowWidth < 992 && !this.isMobile) this.forceRerender();
            else if (windowWidth >= 992 && this.isMobile) this.forceRerender();

            this.isMobile = windowWidth < 992 ? true : false;
        },
		pageRefs() {
            const url = "./references";
            window.location.href = url;
        },
    },
};
</script>

<style lang="scss" scoped>
.more-ref {
	position : relative; 
	margin-bottom: 9rem;
	
	> div {
		border-radius: 15px;
		background: rgba(0, 0, 0, 0.05);
		width: 100%;
		display: flex;
		flex-flow: column;
		margin: auto;
		height: 100%;
		padding: 2rem 0;

		> div {
			overflow: hidden;
			height: 100%;
			box-shadow: 0 0 0;
			display: flex;
			flex-flow: column;
			align-items: center;
			justify-content: center;
		}

		.img {
			flex: 2;
			width: 100%;
			display: block;
			display: flex;
			align-items: center;
			justify-content: center;

			> span {
				padding: 2.4rem;
				box-sizing: border-box;
				height: 120px;
				width: 120px;
				display: flex;
				align-items: center;
				justify-content: center;
				background-color: #fff;
				border-radius: 100px;
				box-shadow: 0px 0px 7px 2px rgba(0, 0, 0, 0.1);
				margin-bottom: 1rem;

				svg {
					height: 100%;
					width: auto;
					fill: red;
				}
			}
		}

		.more {
			flex: 1;
			text-align: center;
			font-family: "Roboto", sans-serif;
			font-weight: 300;
			font-size: 1.2rem;
		}
	}
} 


</style>

